import { EditOutlined } from "@ant-design/icons";
import React from "react";

import "./stylesSummary.css";
import { Input } from "antd";

function Summary() {
  return (
    <div className="summary-container">
      <h2>Summary</h2>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>Promo Details</h3>
          <div className="summary-editing">
            <span>Edit</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div className="campaign-name">
          <span>Enter Campaign Name</span>
          <Input placeholder="Enter Campaign Name" />
        </div>
        <div className="promo-details-body">
          <div className="left-content">
            <div className="channels">
              <span>Description</span>
              <p>
                Get +100% on your Rebet Coins Bundle! Unlock Savings on Rebet
                Cash Purchase!
              </p>
            </div>
            <div className="channels">
              <span>End date</span>
              <p>20 September, 2024 at 10:32 AM (players local time zone)</p>
            </div>
            <div className="channels">
              <span>Deposit Match Percentage</span>
              <p>100%</p>
            </div>
            <div className="channels">
              <span>Max. bonus amount</span>
              <p>$100</p>
            </div>
          </div>
          <div className="right-content">
            <div className="channels">
              <span>Start date</span>
              <p>20 September, 2024 at 10:32 AM (players local time zone)</p>
            </div>
            <div className="channels">
              <span>Expiration Period</span>
              <p>7 days</p>
            </div>
            <div className="channels">
              <span>Min. bonus amount</span>
              <p>-</p>
            </div>
            <div className="channels">
              <span>Terms of Use</span>
              <p>
                <b>Participation Period:</b> <br /> The promotion is applicable
                for any eligible transactions made between February 10th, 00:00
                GMT, and February
              </p>
            </div>
            <span className="show-more">Show more</span>
          </div>
        </div>
      </section>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>Messaging</h3>
          <div className="summary-editing">
            <span>Edit</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div className="channels">
          <span>Channels</span>
          <p>
            E-mail <span>and</span> iOS Push <span>and</span> Purchase Match
          </p>
        </div>
      </section>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>Scheduled Delivery</h3>
          <div className="summary-editing">
            <span>Edit</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div>
          <div className="channels">
            <span>Time-Based Scheduling Options</span>
            <p>
              Send as soon as Promo is launched to players in their local time
              zone
            </p>
          </div>
          <div className="channels">
            <span>How often to send?</span>
            <p>Once, 20 September, 2024 at 10:32 AM</p>
          </div>
          <div className="channels">
            <span>Next Send Time: </span>
            <p>20 September, 2024 at 10:32 AM</p>
          </div>
        </div>
      </section>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>Target Audiences</h3>
          <div className="summary-editing">
            <span>Edit</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div className="channels">
          <div className="channels-row">
            <div style={{ width: "50%" }}>
              <h4>Targeting Options</h4>
              <span>Target Players by Segment</span>
              <p>
                01. All time 25% + GGR {">"} 0 and 05. $1,000 + deposited last
                month {">"} 0
              </p>
            </div>
            <div style={{ width: "50%" }}>
              <h4>A/B Testing</h4>
              <span>Control Group</span>
              <p>50% </p>
            </div>
          </div>
        </div>
        <div className="channels" style={{ width: "100%" }}>
          <div className="channels-row">
            <div style={{ width: "50%" }}>
              <span>Target Players by Segment</span>
              <p>
                Min. number of bets last month = 5 or Min. number of bets last
                month = 1
              </p>
            </div>
            <div style={{ width: "50%" }}>
              <span>Variant 1</span>
              <p>50% </p>
            </div>
          </div>
        </div>
        <div className="channels" style={{ width: "50%" }}>
          <span>Players Location</span>
          <p>All states </p>
        </div>
      </section>
    </div>
  );
}

export default Summary;
